"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resources = exports.defaultLanguage = undefined;
exports.getResource = getResource;
exports.getSupportedLanguagesByProduct = getSupportedLanguagesByProduct;
exports.translateResource = translateResource;
exports.updateLanguageByReload = updateLanguageByReload;
exports.isLanguageSupported = isLanguageSupported;
exports.getLanguage = getLanguage;
exports.getFacebookLanguage = getFacebookLanguage;

var _de = require("react-intl/locale-data/de");

var _de2 = _interopRequireDefault(_de);

var _en = require("react-intl/locale-data/en");

var _en2 = _interopRequireDefault(_en);

var _es = require("react-intl/locale-data/es");

var _es2 = _interopRequireDefault(_es);

var _fr = require("react-intl/locale-data/fr");

var _fr2 = _interopRequireDefault(_fr);

var _hu = require("react-intl/locale-data/hu");

var _hu2 = _interopRequireDefault(_hu);

var _nl = require("react-intl/locale-data/nl");

var _nl2 = _interopRequireDefault(_nl);

var _nb = require("react-intl/locale-data/nb");

var _nb2 = _interopRequireDefault(_nb);

var _pt = require("react-intl/locale-data/pt");

var _pt2 = _interopRequireDefault(_pt);

var _fi = require("react-intl/locale-data/fi");

var _fi2 = _interopRequireDefault(_fi);

var _tr = require("react-intl/locale-data/tr");

var _tr2 = _interopRequireDefault(_tr);

var _url = require("url");

var _url2 = _interopRequireDefault(_url);

var _reactIntl = require("react-intl");

var _Product = require("./Product");

var _de3 = require("../locales/de.json");

var _de4 = _interopRequireDefault(_de3);

var _en3 = require("../locales/en.json");

var _en4 = _interopRequireDefault(_en3);

var _es3 = require("../locales/es.json");

var _es4 = _interopRequireDefault(_es3);

var _fr3 = require("../locales/fr.json");

var _fr4 = _interopRequireDefault(_fr3);

var _hu3 = require("../locales/hu.json");

var _hu4 = _interopRequireDefault(_hu3);

var _nl3 = require("../locales/nl.json");

var _nl4 = _interopRequireDefault(_nl3);

var _nb3 = require("../locales/nb.json");

var _nb4 = _interopRequireDefault(_nb3);

var _pt3 = require("../locales/pt.json");

var _pt4 = _interopRequireDefault(_pt3);

var _fi3 = require("../locales/fi.json");

var _fi4 = _interopRequireDefault(_fi3);

var _tr3 = require("../locales/tr.json");

var _tr4 = _interopRequireDefault(_tr3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookLocales = require("facebook-locales");

(0, _reactIntl.addLocaleData)(_de2.default);
(0, _reactIntl.addLocaleData)(_fr2.default);
(0, _reactIntl.addLocaleData)(_en2.default);
(0, _reactIntl.addLocaleData)(_es2.default);
(0, _reactIntl.addLocaleData)(_hu2.default);
(0, _reactIntl.addLocaleData)(_nl2.default);
(0, _reactIntl.addLocaleData)(_nb2.default);
(0, _reactIntl.addLocaleData)(_pt2.default);
(0, _reactIntl.addLocaleData)(_fi2.default);
(0, _reactIntl.addLocaleData)(_tr2.default);

var defaultLanguage = exports.defaultLanguage = "en";

// This will determine the order of the language Dropdown
var SupportedLanguages = {
  de: { id: "de", messages: _de4.default },
  en: { id: "en", messages: _en4.default },
  es: { id: "es", messages: _es4.default },
  fr: { id: "fr", messages: _fr4.default },
  hu: { id: "hu", messages: _hu4.default },
  nl: { id: "nl", messages: _nl4.default },
  nb: { id: "nb", messages: _nb4.default },
  pt: { id: "pt", messages: _pt4.default },
  fi: { id: "fi", messages: _fi4.default },
  tr: { id: "tr", messages: _tr4.default }
};

var BusinessSupportedLanguages = {
  en: { id: "en", messages: _en4.default },
  es: { id: "es", messages: _es4.default },
  fr: { id: "fr", messages: _fr4.default }
};

// TODO SVODAPPS-1833 Change Qello image
var resources = exports.resources = {
  AppleStore: { id: 1, resourceName: "apple_store.svg" },
  GoogleStore: { id: 2, resourceName: "google_store.png" },
  StingrayMusicLogoHorizontal: {
    id: 3,
    resourceName: "stingray_music_hor_white.svg"
  },
  StingrayMusicBackground: { id: 4, resourceName: "stingray_music.jpg" },
  StingrayBusinessBackground: { id: 5, resourceName: "stingray_business.png" },
  StingrayBusinessLogoHorizontal: {
    id: 6,
    resourceName: "stingray_business_logo_horizontal.svg"
  },
  StingrayClassicaLogoHorizontal: {
    id: 7,
    resourceName: "stingray_classica_horizontal.svg"
  },
  StingrayClassicaBackground: { id: 8, resourceName: "stingray_classica.jpg" },
  StingrayClassicaBackgroundMobile: {
    id: 9,
    resourceName: "stingray_classica_mobile.jpg"
  },
  StingrayClassicaBackgroundTablet: {
    id: 10,
    resourceName: "stingray_classica_tablet.jpg"
  },
  StingrayQelloLogoHorizontal: {
    id: 11,
    resourceName: "stingray_qello_horizontal.svg"
  },
  StingrayQelloBackground: { id: 12, resourceName: "stingray_qello.jpg" },
  StingrayQelloBackgroundMobile: {
    id: 13,
    resourceName: "stingray_classica_mobile.jpg"
  },
  StingrayQelloBackgroundTablet: {
    id: 14,
    resourceName: "stingray_classica_tablet.jpg"
  },
  KaraokeLogoHorizontal: { id: 15, resourceName: "stingray_karaoke_logo.png" },
  TSMKaraokeLogoHorizontal: {
    id: 16,
    resourceName: "logo-smc-white.svg"
  },
  StingrayLogoHorizontal: {
    id: 17,
    resourceName: "stingray_logo_horizontal.svg"
  },
  StingrayKaraokeBackground: { id: 18, resourceName: "stingray_karaoke.png" }
};

function getResource(lang, res) {
  var resource = void 0;

  try {
    var backgroundImages = [resources.StingrayMusicBackground, resources.StingrayBusinessBackground, resources.StingrayClassicaBackground, resources.StingrayClassicaBackgroundMobile, resources.StingrayClassicaBackgroundTablet, resources.StingrayQelloBackground, resources.StingrayQelloBackgroundMobile, resources.StingrayQelloBackgroundTablet, resources.StingrayKaraokeBackground];
    if (backgroundImages.includes(res)) {
      resource = require("../../res/images/backgrounds/" + lang + "/" + res.resourceName);
    } else {
      resource = require("../../res/images/logo/" + lang + "/" + res.resourceName);
    }
  } catch (ex) {
    if (lang !== SupportedLanguages.en.id) {
      resource = getResource(SupportedLanguages.en.id, res);
    }
  }
  return resource;
}

function getSupportedLanguagesByProduct(realm, product) {
  var supportedLanguages = void 0;

  switch (true) {
    case realm === _Product.REALM_NAMES.Business && product === _Product.PRODUCT_NAMES.Music:
      supportedLanguages = BusinessSupportedLanguages;
      break;
    default:
      supportedLanguages = SupportedLanguages;
      break;
  }

  return supportedLanguages;
}

function translateResource(lang, res) {
  var resource = getResource(lang, res);
  return resource;
}

function updateLanguageByReload(newLang) {
  var newUrl = _url2.default.parse(window.location.href, true);
  newUrl.query.language = newLang;
  newUrl.search = "";
  var uri = _url2.default.format(newUrl);
  window.location.replace(uri);
}

function isLanguageSupported(realm, product, lang) {
  var supportedLanguages = getSupportedLanguagesByProduct(realm, product);

  return !!supportedLanguages[lang];
}

function getLanguage(realm, product, lang) {
  var supportedLanguages = getSupportedLanguagesByProduct(realm, product);

  return supportedLanguages[lang] ? supportedLanguages[lang] : supportedLanguages.en;
}

// For all the Facebook languages
// https://www.facebook.com/translations/FacebookLocales.xml
function getFacebookLanguage(language, countryCode) {
  var facebookLanguage = "en_US";

  // FacebookLocales doesn't work great with es (spanish) it default back to es_CL which facebook doesn't support
  if (language === SupportedLanguages.es.id) {
    facebookLanguage = "es_LA";
  } else {
    facebookLanguage = FacebookLocales.bestFacebookLocaleFor(language + "_" + countryCode);
  }
  return facebookLanguage;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Language.js
// module id = 141
// module chunks = 0